import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/app-state';
import { ClickableText, Container } from './index.styled';
import HeaderModal from '../../../common/header-modal/header-modal';
import { Button, Text } from '../../../common';
import { useTheme } from 'styled-components';
import { fetchHideModal, sendEmailAccountConfirmation } from '../../../../store/auth/auth-actions';
import { useTranslation } from 'react-i18next';
import Input from '../../../form/Input/input';


const SendEmailModal: React.FC = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { t } = useTranslation('private-home-page', { keyPrefix: 'account-confirmation.modal' });
    const { user, accountConfirmation } = useSelector((state: AppState) => state.authState);
    const [enableEmail, setEnableEmail] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    
    const handleCloseModal = useCallback(() => {
        dispatch(fetchHideModal());
        setEnableEmail(false);
        setEmail('');
    }, [dispatch]);

    const handleSendEmail = useCallback(() => {
        if (user) {
            dispatch(sendEmailAccountConfirmation(user.id, email.length > 0 ? email : undefined));
        }
    }, [dispatch, user, email]);

    const render = useCallback(() => {
        if (accountConfirmation && accountConfirmation.errorMessage) {
            return (
                <Container>
                    <Text
                        color={theme.colors.error.main}
                        align='justify'
                    >
                        {t(accountConfirmation.errorMessage)}
                    </Text>
                </Container>
            );
        }

        return (
            <Container>
                <Text
                    color={theme.colors.primaryBlue.main}
                    align='justify'
                >
                    {t('msg-1')}
                </Text>
                <Text
                    color={theme.colors.primaryPurple.main}
                >
                    {user && user.email}
                </Text>
                {accountConfirmation && accountConfirmation.byAction && (
                    <Text
                        color={theme.colors.primaryBlue.main}
                        align='justify'
                    >
                        {t('msg-2')}
                    </Text>
                )}
                {enableEmail && (
                    <div style={{margin: '1rem 0'}}>
                        <Text
                            color={theme.colors.primaryBlue.main}
                        >
                            {t('msg-4')}
                        </Text>
                        <Input
                            name="email"
                            type="text"
                            placeholder=""
                            value={email}
                            debounceDelay={0}
                            onDeboncedValueChange={(value) => setEmail(value || '')}
                        />
                    </div>
                )}
                <Button
                    textColor={theme.colors.white.main}
                    backgroundColor={theme.colors.primaryPurple.main}
                    onClick={handleSendEmail}
                >
                    {t('button')}
                </Button>
                {!enableEmail && (
                    <Text
                        fontSize={12}
                        color={theme.colors.gray400.main}
                    >
                        {t('msg-3')}, 
                        <ClickableText onClick={() => setEnableEmail(true)}>{t('link')}</ClickableText>.
                    </Text>
                )}
            </Container>
        );
    }, [accountConfirmation, theme, t, user, enableEmail, email, handleSendEmail]);

    return (
        <HeaderModal
            onClose={handleCloseModal}
            backdropToggle={handleCloseModal}
            showModal={accountConfirmation && accountConfirmation.showModal}
            title='Confirme sua conta'
            width='30rem'
            closeOnEsc={true}
        >
            {render()}
        </HeaderModal>
    )
};

export default SendEmailModal;
